<ng-template #connectingTemplate>
	<mat-card-content>
		<mat-spinner-icon diameter="70" class="mat-spinner-center mat-spinner-thin">
			<mat-icon>how_to_reg</mat-icon>
		</mat-spinner-icon>
	</mat-card-content>
	<mat-card-header style="justify-content: center; text-align: center;">
		<mat-card-title>Authentification</mat-card-title>
		<mat-card-subtitle>Merci de patienter...</mat-card-subtitle>
	</mat-card-header>
</ng-template>

<ng-template #supportTemplate>
	<mat-card-content>
		<support inline></support>
	</mat-card-content>
	<mat-card-actions>
		<button mat-button (click)="connectState.views.pop()">
			<mat-icon>navigate_before</mat-icon>
			Retour
		</button>
	</mat-card-actions>
</ng-template>

<ng-template #betaTemplate>
    <ng-container *ngIf="!connectState.isWaiting; else connectingTemplate">
        <mat-list>
            <div mat-subheader [ngClass]="{'mat-accent-gradient': isBeta, 'mat-night-gradient': isDevelopment}">
                <mat-icon>{{isBeta ? 'science' : 'code'}}</mat-icon>
                Environnement de {{isDevelopment ? 'développement' : ''}} {{isBeta ? 'test (Beta)' : ''}}
            </div>
            <mat-list-item>Certaines fonctionnalitées pourrait être instable ou provoquer des résultats inattendus</mat-list-item>
            <mat-list-item>Les modifications ou nouveaux enregistrements effectués pourraient être effacés</mat-list-item>
        </mat-list>
        <mat-card-actions align="end">
            <button mat-button (click)="connectState.views.pop()">
                J'ai compris
                <mat-icon>navigate_next</mat-icon>
            </button>
        </mat-card-actions>
    </ng-container>
</ng-template>

<ng-template #azureTemplate>
    <ng-container *ngIf="!connectState.isWaiting; else connectingTemplate">
        <mat-notification *ngIf="connectState.error" [notification]="{message: connectState.error, type: 'warn'}"></mat-notification>
        <!-- <ng-container *ngIf="accounts">
            <mat-nav-list>
                <div mat-subheader class="mat-accent-gradient">
                    Continuer avec mon compte Microsoft.                
                </div>
                <button mat-list-item *ngFor="let account of accounts" (click)="connect(account)">
                    <mat-user-picture mat-list-avatar fxFlexAlign="start" [src]="apiService.pictureOf(account.localAccountId)"></mat-user-picture>
                    <div matLine>{{account.name}}</div>
                    <div matLine class="mat-grey">{{account.username}}</div>
                </button>
            </mat-nav-list>-->
            <mat-card-content>
                <mat-list>
                    <div mat-subheader class="mat-accent-gradient">
                        Continuer avec mon compte Microsoft.
                    </div>
                    Utilisez le bouton suivant pour vous connecter au Portail avec votre compte Microsoft Oxance.<br />
                </mat-list>
            </mat-card-content>
            <mat-card-actions fxLayout="column" fxLayoutAlign="space-between center">
                <button mat-flat-button class="mat-accent-gradient" style="width: 100%;" (click)="connect()">
                    Connexion avec un compte Microsoft
                    <mat-icon>navigate_next</mat-icon>
                </button>
            </mat-card-actions>
        <!-- </ng-container> -->
    </ng-container>
</ng-template>

<div style="position: relative; width: 100%">
    <ng-container *ngIf="!isAuthenticated">
        <img alt="illustration" src="assets/35.svg" style="position: fixed; width: 675px; transform: translate(-280px, -330px);" loading="lazy"/>
        <img alt="illustration" src="assets/logo-app-details.svg" class="illustration illustration-animated" style="top: -20px; z-index: 1;" loading="lazy" />
    </ng-container>
	<mat-card [smoothHeight]="connectState.views.last + connectState.isWaiting" class="mat-elevation-z4">
		<ng-container *ngTemplateOutlet="this[connectState.views.last + 'TemplateRef']"></ng-container>
	</mat-card>
</div>

<div *ngIf="!isAuthenticated" fxLayoutAlign="center center" fxLayoutGap="24px" style="margin-top: 24px;">
	<button mat-button *ngIf="connectState.views.last !== 'support'" (click)="connectState.views.push(Views.Support)">
		Aide
	</button>
	<div class="mat-grey">{{version}}</div>
</div>